export default __webpack_public_path__ + "static/media/records.a888c643.svg";